// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { ComponentType, SVGProps } from "react";
import { SvgErrorGeneric } from "./SvgErrorGeneric";
import { SvgErrorNotFound } from "./SvgErrorNotFound";
import { SvgErrorServer } from "./SvgErrorServer";

export { SvgErrorGeneric, SvgErrorNotFound, SvgErrorServer };

export type ErrorIllustrationComponent = ComponentType<
  SVGProps<SVGSVGElement> & { title?: string; titleId?: string }
>;

export type ErrorIllustrationName =
  "error-generic" | "error-not-found" | "error-server";

export const ErrorIllustrationMap = {
  "error-generic": SvgErrorGeneric,
  "error-not-found": SvgErrorNotFound,
  "error-server": SvgErrorServer,
} satisfies Record<ErrorIllustrationName, ErrorIllustrationComponent>;
